var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirework(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#000000",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1084,
    height: 322,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1084 322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pid-0.11478639074527353",
    x: 0,
    y: 0,
    width: 266.24,
    height: 266.24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.04)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.95656615486234,73.26585654599751)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8537078654123886s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8537078654123886s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.39262451905495,242.66379532386327)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.39262451905495,-13.336204676136731)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.0342243834524653s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.0342243834524653s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.8658328977574,167.6635067191326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.073061777263873s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.073061777263873s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.5782163978477,14.459910325304179)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.42178360215229,14.459910325304179)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.5782163978477,270.4599103253042)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.754871844450657s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.754871844450657s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.59366136703875,54.22522356456528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.182087127631628s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.182087127631628s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.01270872800683,209.66908539607448)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.8428831970974823s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.8428831970974823s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.032571540346623,69.41009058132965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.0325715403466,69.41009058132965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.07615682726263757s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.07615682726263757s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.10350571504517,87.40053544224509)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.896494284954827,87.40053544224509)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.32642942507926326s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.32642942507926326s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.76244496777042,29.466546228781795)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.76244496777042,285.4665462287818)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3904321559870174s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3904321559870174s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.85114621410577,241.45632075668584)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.85114621410577,-14.543679243314159)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9151293286583745s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9151293286583745s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.052500753952586,16.839530183360637)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.052500753952586,272.83953018336064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.4813273951683923s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.4813273951683923s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.87312330237341,118.40508743362619)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9300268939163728s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9300268939163728s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.04439242798372,69.2308833531684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.1776307545969236s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.1776307545969236s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.50688556568025,210.90976615085674)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.50688556568025,210.90976615085674)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#f91a10",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.9824786443287845s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.9824786443287845s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.5075966218355,242.0217225516193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.5075966218355,-13.978277448380709)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#e46b43",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-0.7737256803128685s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-0.7737256803128685s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.32024239525407,2.3770527309479235)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.32024239525407,258.3770527309479)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    x2: 5,
    y1: 0,
    y2: 0,
    stroke: "#5a1414",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    values: "0;1;0",
    begin: "-1.3460014622828025s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1.5384615384615383s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 0;40 0",
    begin: "-1.3460014622828025s"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1084,
    height: 322,
    fill: "url(#pid-0.11478639074527353)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirework);
export default __webpack_public_path__ + "static/media/firework.917a4fee39ea33fd7a2dcdfcefe775f4.svg";
export { ForwardRef as ReactComponent };